import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/lib/auth";
import { PublicLayout } from "@/components/PublicLayout";

import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Apply from "@/pages/Apply";
import About from "@/pages/About";
import Pricing from "@/pages/Pricing";
import Contact from "@/pages/Contact";
import { Privacy, Terms, Refund } from "@/pages/Policies";
import Portal from "@/pages/Portal";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminLeadDetail from "@/pages/admin/AdminLeadDetail";
import AdminCustomers from "@/pages/admin/AdminCustomers";
import AdminCustomerDetail from "@/pages/admin/AdminCustomerDetail";
import AdminCustomerGst from "@/pages/admin/AdminCustomerGst";
import AdminOperators from "@/pages/admin/AdminOperators";
import AdminServices from "@/pages/admin/AdminServices";
import AdminInvoices from "@/pages/admin/AdminInvoices";
import AdminInvoiceDetail from "@/pages/admin/AdminInvoiceDetail";

const withPublic = (El) => (
  <PublicLayout>
    <El />
  </PublicLayout>
);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Toaster richColors position="top-right" />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={withPublic(Home)} />
            <Route path="/services" element={withPublic(Services)} />
            <Route path="/apply/:serviceId" element={withPublic(Apply)} />
            <Route path="/about" element={withPublic(About)} />
            <Route path="/pricing" element={withPublic(Pricing)} />
            <Route path="/contact" element={withPublic(Contact)} />
            <Route path="/privacy" element={withPublic(Privacy)} />
            <Route path="/terms" element={withPublic(Terms)} />
            <Route path="/refund" element={withPublic(Refund)} />

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/login" element={<AdminLogin />} />
            <Route path="/portal" element={<Portal />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="leads" element={<AdminLeads />} />
              <Route path="leads/:leadId" element={<AdminLeadDetail />} />
              <Route path="customers" element={<AdminCustomers />} />
              <Route path="customers/:customerId" element={<AdminCustomerDetail />} />
              <Route path="customers/:id/gst" element={<AdminCustomerGst />} />
              <Route path="operators" element={<AdminOperators />} />
              <Route path="services" element={<AdminServices />} />
              <Route path="invoices" element={<AdminInvoices />} />
              <Route path="invoices/:invoiceId" element={<AdminInvoiceDetail />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
